<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br>
            <span style="text-align: center">
                <header-title title="สร้างใบสั่งซื้อ"></header-title>
            </span>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสผู้จำหน่าย
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                v-model="form.vendor"
                                :options="optionVendor"
                                track-by="vendor_id"
                                :customLabel="LabelVendor"
                                :show-labels="false"
                                placeholder="เลือกผู้จำหน่าย">
                            </multiselect>
                        </div>
                    </div>
                    <!--Vendor data -->
                    <template v-if="form.vendor">
                        <div class="form-group row">
                            <label
                                class="col-sm-4 col-form-label text-capitalize text-right">
                                ผู้จำหน่าย
                            </label>
                            <div class="col-sm-8 col-form-label">
                                <p>
                                    {{ form.vendor.first_name }}
                                    {{ form.vendor.last_name }}
                                </p>
                                <p>{{ form.vendor.address }}</p>
                                <p>โทร {{ form.vendor.phone }}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่เอกสาร
                        </label>
                        <div class="col-sm-8">
                            <masked-input v-model="form.po_number"
                                          mask="PO111111111"
                                          placeholder="เลขที่ PO"
                                          class="form-control"
                                          type="text"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่
                        </label>
                        <div class="col-sm-8">
                            <date-picker
                                v-model="form.date"
                                type="date"
                                :format="changeFormat"
                                :lang="lang"
                                :disabled="disable_date"
                                @input="generatePO"
                                placeholder="วันที่อัพเดต">
                            </date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                        </label>
                        <div class="col-sm-8 form-inline">
                            <label><input type="radio" value="0" v-model="form.status_tax"/>&nbsp;ไม่มีภาษี</label>
                            <label style="margin-left: 20px">
                                <input type="radio" value="1" v-model="form.status_tax"/>&nbsp;มีภาษี
                            </label>
                        </div>
                    </div>
                </div>
                <br>
            </div>
            <div class="col-12 table-responsive" style="min-height: 300px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th width="50px" scope="col">ลำดับ</th>
                        <th width="200px" scope="col">รหัสสินค้า</th>
                        <th width="100px" scope="col">จำนวนที่สั่งซื้อ</th>
                        <th width="100px" scope="col">จำนวนคงเหลือใน PO</th>
                        <th width="100px" scope="col">ราคา/หน่วย</th>
                        <th width="150px" scope="col">ลด</th>
                        <th width="100px" scope="col">ราคารวม</th>
                        <th width="100px" scope="col">เพิ่ม / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(details,index) in form.details">
                        <td>{{ ++index }}</td>
                        <td>
                            <template v-if="details.material">
                                {{ details.material.code }} {{ details.material.name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <input class="form-control"
                                   type="number"
                                   v-model="details.quantity"/>
                        </td>
                        <td>
                            <template v-if="details.remaining">
                                {{ details.remaining }}
                            </template>
                            <template v-else>
                                0
                            </template>
                        </td>
                        <td>
                            <input class="form-control"
                                   type="number"
                                   v-model="details.price"
                            />
                        </td>
                        <td>
                            <b-form inline>
                                <input style="width: 100px"
                                       class="form-control"
                                       type="number"
                                       v-model="details.discount"/>
                                <b-form-select v-model="details.discount_status_id"
                                               :options="discount_type">
                                </b-form-select>
                            </b-form>
                        </td>
                        <td>
                            {{
                                details.discount_status_id == 1
                                    ? details.total = (details.quantity * details.price) - details.discount
                                    : details.total = (details.quantity * details.price) - (details.quantity * details.price) * (details.discount / 100)
                                        | currency
                            }}
                        </td>
                        <td>
                            <a @click="showRemoveDetailsModal(index)">
                                <icon name="trash-alt">
                                </icon>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <multiselect
                                v-model="detail.material"
                                :options="material"
                                track-by="code"
                                :customLabel="labelMaterial"
                                @input="showPriceMaterial(detail.material)"
                                :show-labels="false"
                                placeholder="โปรดเลือกวัตถุดิบ">
                            </multiselect>
                        </td>
                        <td>
                            <input class="form-control"
                                   type="number"
                                   v-model="detail.quantity"
                            />
                        </td>
                        <td>
                            0
                        </td>
                        <td>
                            <input class="form-control"
                                   type="number"
                                   v-model="detail.price"
                            />
                        </td>
                        <td>
                            <b-form inline>
                                <input style="width: 100px"
                                       class="form-control"
                                       type="number"
                                       v-model="detail.discount"/>
                                <b-form-select v-model="detail.discount_status_id"
                                               :options="discount_type">
                                </b-form-select>
                            </b-form>
                        </td>
                        <td>
                            {{ totalDiscount | currency }}
                        </td>
                        <td>
                            <button class="btn btn-primary" @click="onAddMaterial(detail)">
                                +
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br>
            <b-row style="padding-right: 35px">
                <div class="float-right; text-right" style="margin-left: auto;">
                    <table style="font-size: 18px">
                        <tr>
                            <td width="150">รวมทั้งหมด :</td>
                            <td width="150">
                                <template v-if="form.status_tax == 1">
                                    {{ totalPrice | currency }} บาท
                                </template>
                                <template v-else>
                                    {{ totalPrice - calculateIncVat| currency }} บาท
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>ภาษีมูลค่าเพิ่ม 7% :</td>
                            <td>{{ calculateIncVat | currency }} บาท</td>
                        </tr>
                        <tr>
                            <td>ยอดรวม :</td>
                            <td>{{ calculateTaxTotal | currency }} บาท</td>
                        </tr>
                    </table>
                </div>
            </b-row>
            <br/><br/>
            <b-row>
                <div class="col text-right">
                    <button v-if="form.status != 2"
                            class="btn btn-success mb-3"
                            @click="savePurchaseOrder"
                            style="margin-right: 20px">
                        <icon name="check"></icon>
                        ยืนยันการสั่งซื้อ
                    </button>
                    <button v-if="id"
                            class="btn btn-danger mb-3"
                            @click="showDeleteModal"
                            style="margin-right: 20px">
                        <icon name="trash-alt"></icon>
                        ลบ
                    </button>
                </div>
            </b-row>
            <br/>
        </div>
        <!--Modal Delete-->
        <b-modal
            ref="delete_item"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="removeDetails">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-outline-secondary"
                        @click="hideRemoveDetailsModal">ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--modal delete purchase-->
        <b-modal hide-header hide-footer ref="delete_data">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deletePurchaseOrder"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import HeaderTitle from "../../HeaderTitle";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import MaskedInput from 'vue-masked-input'

export default {
    components: {
        HeaderTitle,
        DatePicker,
        Multiselect,
        MaskedInput
    },
    name: "purchase-order-form",
    // props: {
    //     id: { default: null }
    // },
    data() {
        return {
            optionVendor: [],
            material: [],
            disable_date: false,
            detail: {
                material: "",
                quantity: 0,
                price: 0,
                remaining: 0,
                promotion: "",
                discount: 0,
                discount_status_id: 1,
                total: 0,
                status: 1
            },
            items: [
                {
                    text: "รายการสร้าง PO",
                    to: {name: "purchase-order"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            discount_type: [
                {value: '1', text: '฿'},
                {value: '2', text: '%'}
            ],
            delete_index: "",
            total: 0,
            inc_vat: 0,
            tax: 7,
            vat: 1.07,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        if (!this.$route.query.id) {
            this.$store.dispatch("PurchaseOrder/clearFormData");
            this.generatePO();
        } else {
            this.disable_date = true;
            this.id = window.atob(this.$route.query.id);
            this.getdetailsdata(this.id);
        }
        this.getVendorAll();
        this.getMaterialAll();
    },
    computed: {
        ...mapState({
            form: state => {
                return state.PurchaseOrder.form;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        totalPrice() {
            this.total = this.form.details.reduce((carry, detail) => {
                return carry + detail.total
            }, 0);
            return this.total = parseFloat(this.total).toFixed(2);
        },
        totalDiscount() {
            let total_discount = 0;
            if (this.detail.discount_status_id == 1) {
                total_discount = (this.detail.quantity * this.detail.price) - this.detail.discount;
            } else {
                const calculate = (this.detail.quantity * this.detail.price) * (this.detail.discount / 100);
                total_discount = (this.detail.quantity * this.detail.price) - calculate
            }
            return parseFloat(total_discount).toFixed(2)
        },
        calculateIncVat() {
            this.inc_tax = 0;
            if (this.form.status_tax == 1) {
                this.inc_tax = parseFloat(this.total) * (this.tax / 100)
            } else {
                let tax = parseFloat(this.total) / this.vat;
                this.inc_tax = this.total - tax;
            }
            return this.inc_tax = parseFloat(this.inc_tax).toFixed(2)
        },
        calculateTaxTotal() {
            let total = 0;
            if (this.form.status_tax == 1) {
                total = parseFloat(this.total) + parseFloat(this.inc_tax)
            } else {
                total = parseFloat(this.total)
            }
            return parseFloat(total).toFixed(2)
        },
    },
    methods: {
        getdetailsdata(id) {
            this.$store.dispatch('PurchaseOrder/show', id)
        },
        labelMaterial(option) {
            return `${option.code} - ${option.name}`
        },
        LabelVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showDeleteModal() {
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        showPriceMaterial(material) {
            if (material) {
                this.detail.price = material.price;
                this.detail.remaining = material.quantity;
            } else {
                this.detail.price = 0
            }
        },
        getMaterialAll() {
            this.$store.dispatch("Material/getAll").then(res => {
                this.material = res;
            });
        },
        getVendorAll() {
            this.$store.dispatch("PurchaseOrder/getVendorAll").then(res => {
                this.optionVendor = res;
            });
        },
        onAddMaterial(detail) {
            if (!detail.material) {
                alert('กรุณาเลือกรายการสินค้า')
            } else if (detail.quantity < 1) {
                alert('กรุณาใส่จำนวน');
            } else {
                //console.log(detail.price);
                if (!detail.price) {
                    detail.price = 0;
                }
                if (!detail.discount) {
                    detail.discount = 0;
                }
                detail.quantity = parseInt(detail.quantity);
                detail.discount = parseInt(detail.discount);
                detail.remaining = detail.quantity;
                detail.total = this.totalDiscount;
                this.$store.dispatch("PurchaseOrder/addMaterialDetail", detail).then(() => {
                    this.detail = {
                        material: "",
                        quantity: 0,
                        price: 0,
                        remaining: 0,
                        promotion: "",
                        discount: 0,
                        discount_status_id: 1,
                        total: 0,
                        status: 1
                    }
                });
            }
        },
        savePurchaseOrder() {
            if (!this.form.vendor) {
                alert('กรุณาเลือกผู้จำหน่าย')
            } else if (this.form.details.length < 1) {
                alert('กรุณาเพิ่มรายการวัตถุดิบ');
            } else if (!this.form.date) {
                alert("กรุณาเลือกวันที่")
            } else {
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");
                this.$store.dispatch('PurchaseOrder/createByForm', {
                    id: this.id,
                    user: this.user.id
                }).then(res => {
                    if (res) {
                        this.goToPOList();
                        window.close();
                    } else {
                        alert("เลข PO ซ้ำ / ใส่ข้อมูลไม่ถูกต้อง")
                    }
                })
            }
        },
        deletePurchaseOrder() {
            this.$store.dispatch('PurchaseOrder/delete', this.id)
                .then(() => {
                    this.hideDeleteModal();
                    this.goToPOList();
                });
        },
        goToPOList() {
            this.$router.push({name: 'purchase-order'})
        },
        showRemoveDetailsModal(index) {
            this.delete_index = index - 1;
            this.$refs.delete_item.show();
        },
        hideRemoveDetailsModal() {
            this.$refs.delete_item.hide();
        },
        removeDetails() {
            this.$store.dispatch("PurchaseOrder/removeMaterial", this.delete_index);
            this.hideRemoveDetailsModal();
        },
        generatePO() {
            if (this.form.date) {
                let date = moment(this.form.date).format('YYYY-MM-DD');
                this.$store.dispatch('PurchaseOrder/generatePO', date).then(res => {
                    this.form.po_number = res;
                });
            }
        }
    }
}
</script>

<style scoped>
thead {
    background-color: gray;
}

tbody {
    background-color: white;
}
</style>
